/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Ticket } from '@touchplan/common';

export class FloatingTicket extends Ticket {
	constructor(data?) {
		super(data, FloatingTicket.getId());
	}
	public static idCounter = 1;

	public isAFloatingTicket = true;
	public static getId() {
		let id = '-float-' + FloatingTicket.idCounter;
		FloatingTicket.idCounter++;
		return id;
	}
}
